import React from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/es/form';
import NumericKeyboard from '@/components/NumericKeyboard';
import { PaymentChannel } from '@/models/payment';
import styles from '../style.less';
import { RedEnvelopeOutlined } from '@ant-design/icons';

type Props = {
  form: FormInstance;
};

const DirectTradeArea: React.FC<Props> = ({ form }: Props) => {
  return (
    <div className={styles.item}>
      <h3>
        <RedEnvelopeOutlined /> 待收款金额
      </h3>
      <Form.Item noStyle name={'actualPrice'}>
        <NumericKeyboard
          placeholder={'请输入待收款金额'}
          parseValueToNumber
          precision={2}
          onChange={() => {
            if (!form.getFieldValue('actualPrice')) {
              form.setFieldsValue({
                paymentChannel: PaymentChannel.Online,
              });
            }
          }}
        />
      </Form.Item>
    </div>
  );
};

export default DirectTradeArea;
